import React from 'react'
import { TreasureHuntTile } from './TreasureHuntTile'

export const TreasureHuntPreviewTiles = ({ tiles, rows, cols, colorTheme, isModal }) => {
    return (
        <div className="treasure-hunt-preview-tiles-container">
            {tiles.map((tile, i) => (
                <TreasureHuntTile key={i} tile={tile} rows={rows} cols={cols} colorTheme={colorTheme} isModal={isModal}/>
            ))}
        </div>
    )
}
